import { commits } from '@/modules/core/app/helpers/store';

export const actions = {
  addToUndoStack({}, operation) {
    commits.undo.addToUndoStack(operation);
  },
  addToDoStack({}, operation) {
    commits.undo.addToDoStack(operation);
  },
  clearUndoStack() {
    commits.undo.clearUndoStack();
  },
  clearDoStack() {
    commits.undo.clearDoStack();
  },
  popDoStack() {
    commits.undo.popDoStack();
  },
  popUndoStack() {
    commits.undo.popUndoStack();
  },
  updateCurrentOperationPromise({}, currentOperationPromise) {
    commits.undo.updateCurrentOperationPromise(currentOperationPromise);
  },
};
